import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root'
})
export class DateTimeService {

	constructor () { }

	// converts JavaScript Date into YYYY-MM-DD string
	toBackendDate(d: Date): string {
		return  [
			d.getFullYear(),
			('0' + (d.getMonth() + 1)).slice(-2),
			('0' + d.getDate()).slice(-2)
		].join('-');
	}

	generateDatesStartingFromToday(count: number): Date[] {

		const res = [];
		const startDate = new Date();

		for (let i = 0; i < count; i++) {
			const newDate = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate() + i);
			res.push(newDate);
		}

		return res;
	}

	generateDateStringsStartingFromToday(count: number): string[] {

		const res = [];
		const startDate = new Date();

		for (let i = 0; i < count; i++) {
			const newDate = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate() + i);
			res.push(this.toBackendDate(newDate));
		}

		return res;
	}

	isDateInPast(date: Date): boolean {
		const currentDate = new Date();
		return date < currentDate;
	}

	isTodayWithinRangeBeforeDate(date: Date, rangeInDays: number): boolean {
		const currentDate = new Date();
		var rangeDate = new Date(date);
		rangeDate.setDate(rangeDate.getDate() - rangeInDays);

		return currentDate >= rangeDate && currentDate <= date;

		//return date >= rangeDate && date <= currentDate;
	}
}
